export function virtualOperatorToOperator(virtualOperator: OperatorApplicationApi.OperatorGetParamsSiteVirtualOperatorOpenApiModel): OperatorApplicationApi.OperatorGetParamsOperatorOpenApiModel {
    return {
        fio: virtualOperator.descr,
        login: virtualOperator.descr,
        avatar: virtualOperator.avatar,
        id: virtualOperator.id,
        mentionContentVariableId: ""
    };
}